import { Dispatch, SetStateAction } from 'react'
import { UseFormSetValue } from 'react-hook-form'
import {
  BackgroundType,
  BgmFactor,
  PromptDuration,
  ShortVideoTemplateType,
  SubtitleColorType,
  SubtitleType,
  TempoType,
  ToneType,
  VoiceGroupFactor,
} from 'service/list'
import {
  contentVideoFormValues,
  contentVideoTextTypeFormValues,
} from 'utils/type'

export const initializeDefaults = ({
  setValue,
  toneList,
  voiceList,
  templateList,
  bgList,
  bgmList,
  subTitleList,
  aiPromptDurationList,
  subtitleColorList,
  tempoList,
  setSelectedImagePath,
}: {
  setValue: UseFormSetValue<contentVideoFormValues>
  toneList: ToneType[] | undefined
  voiceList: VoiceGroupFactor[]
  templateList: ShortVideoTemplateType | undefined
  bgList: BackgroundType[] | undefined
  bgmList: BgmFactor[] | undefined
  subTitleList: SubtitleType[] | undefined
  aiPromptDurationList: PromptDuration[] | undefined
  subtitleColorList: SubtitleColorType[] | undefined
  tempoList: TempoType[] | undefined
  setSelectedImagePath: Dispatch<SetStateAction<string>>
}) => {
  console.log('init option')

  setDefaultValueFromList(voiceList, setValue, 'voiceId')
  setDefaultValueFromList(bgmList, setValue, 'bgmId')
  setDefaultValueFromList(subTitleList, setValue, 'subtitleId')
  setDefaultValueFromList(subtitleColorList, setValue, 'subtitleColorId')
  setDefaultValueFromList(tempoList, setValue, 'tempoId')
  setDefaultValueFromList(toneList, setValue, 'aiToneTypeId')

  if (templateList) {
    const defaultItem = templateList?.placid?.list.find(
      (el) => el.default === 1
    )
    if (defaultItem)
      if (defaultItem) {
        setValue('templateId', defaultItem.id)
        setValue('templateType', defaultItem.type)
        setSelectedImagePath(defaultItem.path)
      }
  }

  setFirstItemFromList(aiPromptDurationList, setValue, 'aiPromptDurationId')
}

export const setFirstItemFromList = <T extends { id: number }>(
  list: T[] | undefined,
  setValue: UseFormSetValue<contentVideoFormValues>,
  field: keyof contentVideoFormValues
) => {
  if (!list || list.length === 0) return
  setValue(field, list[0].id)
}

export const setDefaultValueFromList = <
  T extends { id: number; default: number }
>(
  list: T[] | undefined,
  setValue: UseFormSetValue<contentVideoFormValues>,
  field: keyof contentVideoFormValues
) => {
  if (!list) return

  const defaultItem = list.find((el) => el.default === 1)
  if (defaultItem)
    setValue(field as keyof contentVideoFormValues, defaultItem.id)
}

export const setDefaultValueFromListInTextvideo = <
  T extends { id: number; default: number }
>(
  list: T[] | undefined,
  setValue: UseFormSetValue<contentVideoTextTypeFormValues>,
  field: keyof contentVideoTextTypeFormValues
) => {
  if (!list) return

  const defaultItem = list.find((el) => el.default === 1)
  if (defaultItem)
    setValue(field as keyof contentVideoTextTypeFormValues, defaultItem.id)
}

export function splitTextIntoScenes(
  storyText: string,
  partsNumber: number
): string[] {
  // 문장 단위로 나누기 (정규식: ., !, ? 뒤의 공백 기준)
  const sentences = storyText.trim().split(/(?<=[.!?])/)

  const convertSentences = sentences.filter((el) => el)

  return convertSentences
}

/**
 * 파일명이 허용된 확장자 목록에 포함되지 않는 경우 true 반환
 *
 * @param filename - 검사할 파일 이름 (예: "photo.jpeg")
 * @param allowedExtensions - 허용된 확장자 배열 (예: ["jpg", "png"])
 * @returns boolean - 허용되지 않은 확장자면 true, 허용된 확장자면 false
 */
export function isInvalidFileExtension(
  filename: string,
  allowedExtensions: string[]
): boolean {
  const extension = filename.split('.').pop()?.toLowerCase()

  if (!extension) {
    return true // 확장자가 없을 경우도 잘못된 것으로 간주
  }

  return !allowedExtensions.map((ext) => ext.toLowerCase()).includes(extension)
}
